import { Box } from '@mui/material';
import { RotorElement } from '../../generalComponents/rotorElement/RotorElement';
import { SubmersiblePumpIcon } from 'src/assets/icons/SCADA/assetsComponents/SubmersiblePumpIcon';

type Props = {
  width?: number;
  height?: number;
  isAlarmActive: boolean;
  isRunning: boolean;
};

export const SubmersiblePump = ({ width, height, isAlarmActive, isRunning }: Props) => {
  const widthOfElement = width ?? 180;
  const heightOfElement = height ?? 380;

  let testId = 'offState';

  if (isAlarmActive) {
    testId = `activeAlarm-${isRunning ? 'onState' : 'offState'}`;
  } else if (isRunning && !isAlarmActive) {
    testId = 'onState';
  }
  return (
    <Box position="relative" width="fit-content" height="fit-content" data-sm={testId}>
      <SubmersiblePumpIcon width={widthOfElement} height={heightOfElement} />

      <Box sx={{ position: 'absolute', left: '40%', bottom: '10%' }}>
        <RotorElement
          width={widthOfElement * 0.3}
          height={heightOfElement * 0.3}
          isAlarmActive={isAlarmActive}
          isRunning={isRunning}
        />
      </Box>
    </Box>
  );
};
